import React, { useContext } from 'react';
import { Input, Tooltip, DatePicker } from 'antd';
import styles from './TestEmailModal.styles.js';
import { AppContext } from 'App.context.js';
import moment from 'moment';

export default function TestEmailModal({ setMail, actions, state }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const urlTags = [
    '[checkin_url]',
    '[checkout_url]',
    '[payment_url]',
    '[door_opening_url]',
    '[upsell_url]',
    '[cross-sell_url]',
  ];

  const tagsInText = state?.tagsInText || [];

  const handleTagChange = (tagKey, value) => {
    if (actions?.updateTagValue) {
      actions.updateTagValue(tagKey, value);
    }
  };

  // exclude tags de hotel
  const hotelTagKeys = [
    'CIF',
    'CIF_postal_code',
    'CIF_city',
    'CIF_province',
    'CIF_country',
    'CIF_business_name',
    'CIF_business_email',
  ];

  let nonUrlTags = tagsInText.filter(
    tagObj => !urlTags.includes(`[${tagObj.key}]`) && !hotelTagKeys.includes(tagObj.key)
  );

  // Check if there is at least one deeplink tag
  const hasDeeplinkTag = tagsInText.some(tagObj => urlTags.includes(`[${tagObj.key}]`));

  // Add '[entrance_date]' and '[reference_number]' only if there is a deeplink tag
  if (hasDeeplinkTag) {
    const tagKeys = nonUrlTags.map(tag => tag.key);
    if (!tagKeys.includes('entrance_date')) nonUrlTags.push({ key: 'entrance_date', value: '' });
    if (!tagKeys.includes('reference_number'))
      nonUrlTags.push({ key: 'reference_number', value: '' });
  }

  const getTooltipText = key => {
    if (hasDeeplinkTag && (key === 'entrance_date' || key === 'reference_number'))
      return translate('mailTemplates.tagUsedForDeeplink');
    return '';
  };

  return (
    <div>
      <div style={styles.title}>{translate('mailTemplates.testButton')}</div>
      <div style={styles.desc}>{translate('mailTemplates.testMailDesc')}</div>

      <Input
        onChange={e => setMail?.(e.target.value)}
        placeholder={translate('mailTemplates.emailListHint')}
      />

      {nonUrlTags.map(tagObj => (
        <div key={tagObj.key} style={{ marginTop: 10 }}>
          {hasDeeplinkTag &&
          (tagObj.key === 'entrance_date' || tagObj.key === 'reference_number') ? (
            <Tooltip title={getTooltipText(tagObj.key)}>
              <label>
                {`Tag: [${tagObj.key}]`}
                <span style={{ color: 'red', marginLeft: 4 }}>*</span>
              </label>
            </Tooltip>
          ) : (
            <label>{`Tag: [${tagObj.key}]`}</label>
          )}

          {/* Render DatePicker for entrance_date or departure_date */}
          {tagObj.key === 'entrance_date' || tagObj.key === 'departure_date' ? (
            <DatePicker
              style={{ width: '100%' }}
              value={tagObj.value ? moment(tagObj.value, 'YYYY-MM-DD') : null}
              onChange={date => handleTagChange(tagObj.key, date ? date.format('YYYY-MM-DD') : '')}
              placeholder={`${translate('mailTemplates.replaceTagValue')} [${tagObj.key}]`}
            />
          ) : (
            <Input
              value={tagObj.value || ''}
              onChange={e => handleTagChange(tagObj.key, e.target.value)}
              placeholder={`${translate('mailTemplates.replaceTagValue')} [${tagObj.key}]`}
            />
          )}
        </div>
      ))}
    </div>
  );
}
